import React from 'react';
import { Backdrop, CircularProgress, Box } from '@mui/material';

const OverlayLoader = ({ open }) => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      open={open}
    >
      <CircularProgress color="inherit" />
      <Box mt={2}>NFT minting under progress.Please do not refresh the page</Box>
    </Backdrop>
  );
};

export default OverlayLoader;
